function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledBackgroundImageCard } from "./desktop-background-image-cards.scss";
import { generateCloudinaryImageUrl, generateCloudinaryVideoUrl } from "services/community/cloudinary-service";
import classnames from "classnames";
import CardButton from "../card-button/card-button";
const DEFAULT_PARAGRAPH = {
    topic: {}
};
const COLOUDINERY_FIRST_FRAME_FORMAT = "so_0";
const IMAGE_EXTENSION = "jpg";
const DesktopBackgroundImageCard = ({ backgroundVideo, cardHeight, paragraph, fullParagraphAdvancedConfig, button, onHover, backgroundImage, marginRight, marginLeft, marginTop, marginBottom, borderRadius })=>{
    const videoRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const videoUrl = useMemo(()=>backgroundVideo && encodeURI(generateCloudinaryVideoUrl(backgroundVideo === null || backgroundVideo === void 0 ? void 0 : backgroundVideo.formats[0])), [
        backgroundVideo
    ]);
    const firstFrameImage = useMemo(()=>{
        if (!videoUrl) return null;
        const firstFrameFormat = videoUrl.replace(/\/upload\//, `/upload/${COLOUDINERY_FIRST_FRAME_FORMAT}/`);
        return firstFrameFormat.replace(/(\.[\w\d_-]+)$/i, `.${IMAGE_EXTENSION}`);
    }, [
        videoUrl
    ]);
    const cardBackgroundImage = useMemo(()=>firstFrameImage || encodeURI(generateCloudinaryImageUrl(backgroundImage)), [
        backgroundImage,
        firstFrameImage
    ]);
    const onMouseEnter = ()=>{
        var _videoRef_current;
        videoRef === null || videoRef === void 0 ? void 0 : (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.play();
        setIsHovered(true);
        onHover === null || onHover === void 0 ? void 0 : onHover();
    };
    const onMouseLeave = ()=>{
        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        setIsHovered(false);
    };
    const getStyle = ()=>{
        const style = {};
        if (marginRight) style.marginRight = marginRight;
        if (marginLeft) style.marginLeft = marginLeft;
        if (marginTop) style.marginTop = marginTop;
        if (marginBottom) style.marginBottom = marginBottom;
        if (borderRadius) style.borderRadius = borderRadius;
        return Object.keys(style).length > 0 ? style : null;
    };
    return /*#__PURE__*/ _jsxs(StyledBackgroundImageCard, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: classnames("background-image-card", {
            active: videoUrl && isHovered
        }),
        cardHeight: cardHeight,
        backgroundImage: cardBackgroundImage,
        style: getStyle(),
        children: [
            videoUrl && /*#__PURE__*/ _jsx("div", {
                className: "background-video",
                children: /*#__PURE__*/ _jsx("video", {
                    ref: videoRef,
                    loop: true,
                    muted: true,
                    children: /*#__PURE__*/ _jsx("source", {
                        src: videoUrl
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "paragraph-wrapper",
                style: {
                    marginTop: fullParagraphAdvancedConfig === null || fullParagraphAdvancedConfig === void 0 ? void 0 : fullParagraphAdvancedConfig.marginTop
                },
                children: [
                    /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraphAdvancedConfig, DEFAULT_PARAGRAPH, paragraph), {
                        titleClassName: "card-title"
                    })),
                    (button === null || button === void 0 ? void 0 : button.buttonType) && /*#__PURE__*/ _jsx(CardButton, _object_spread({}, button))
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card-image"
            })
        ]
    });
};
export default DesktopBackgroundImageCard;
